"use client";
// Small tooltip for the symbols in a row (gap icons, question count, status marks). Any element with a
// data-tip attribute gets one. Rendered outside the zoomed page, so it is zoomed itself and positioned in page
// pixels.
import type { Board, Priority } from "@/lib/types.ts";
import type { Graph } from "./graph.ts";

/** A feature counts as Muss if it covers any Muss requirement, else Soll, else Kann (optional). */
export function featurePriority(graph: Graph, board: Board, featureId: number): Priority | null {
  const prios = new Set(
    (graph.reqsOfFeature.get(featureId) ?? []).map((r) => board.requirements.find((x) => x.id === r)?.priority),
  );
  return prios.has("Muss") ? "Muss" : prios.has("Soll") ? "Soll" : prios.has("Kann") ? "Kann" : null;
}

export interface TipAt {
  text: string;
  left: number;
  top: number;
  bottom: number;
}

export function Tip({ at, scale }: { at: TipAt; scale: number }) {
  const width = 320;
  const below = at.bottom + 120 < window.innerHeight;
  const left = Math.max(8, Math.min(at.left - 8, window.innerWidth - width * scale - 8));
  const style: React.CSSProperties = {
    zoom: scale,
    left: left / scale,
    maxWidth: width,
    ...(below ? { top: (at.bottom + 6) / scale } : { bottom: (window.innerHeight - at.top + 6) / scale }),
  };
  return (
    <div className="tip" style={style} role="tooltip">
      {at.text}
    </div>
  );
}
